"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelCard = require("../HotelCard.proptypes");
var BoxStyles = _styledComponents.default.div.withConfig({
  displayName: "BogoFomoLabel__BoxStyles",
  componentId: "sc-14r6rmd-0"
})(["background-color:#c82828;border-radius:4px;padding-top:4px;padding-bottom:4px;padding-left:4px;padding-right:4px;align-items:center;justify-content:center;color:white;"]);
var ContainerStyle = _styledComponents.default.div.withConfig({
  displayName: "BogoFomoLabel__ContainerStyle",
  componentId: "sc-14r6rmd-1"
})(["padding-bottom:5px;"]);
var BogoPromoLabel = function BogoPromoLabel(_ref) {
  var BogoTag = _ref.BogoTag;
  return /*#__PURE__*/_react.default.createElement(ContainerStyle, null, /*#__PURE__*/_react.default.createElement(BoxStyles, null, BogoTag));
};
BogoPromoLabel.propTypes = _HotelCard.BogoFomoLabelPropTypes;
BogoPromoLabel.defaultProps = _HotelCard.BogoPromoLabelDefaultProps;
var _default = BogoPromoLabel;
exports.default = _default;